import { useAppSelector } from "src/store/actions/action";

const setQueryString = (params: any) => {
  let returnValue = "";

  let cateQuater = "&";
  let storeQuater = "&";
  let dateQuater = "&";
  let contentsQuater = "&";
  let progressQuater = "&";

  if (params[0].check.indexOf("A") > -1) {
    cateQuater = "?";
  } else if (params[0].check.indexOf("B") > -1) {
    storeQuater = "?";
  } else if (params[0].check.indexOf("C") > -1) {
    dateQuater = "?";
  } else if (params[0].content) {
    contentsQuater = "?";
  } else if (params[0].progress) {
    progressQuater = "?";
  }

  let cateFilter = "";
  let storeFilter = "";
  let progressFilter = "";
  let dateFilter = "";

  let cateIdx = 0;
  let storeIdx = 0;
  let progressIdx = 0;
  let dateIdx = 0;
  for (let i = 0; i < params[0].check.length; i++) {
    const check = params[0].check[i];
    const code = params[0].code[i];
    if (check === "A") {
      if (cateIdx === 0) {
        cateFilter = cateQuater + "filter.cate_idx=$in:" + code;
        cateIdx++;
      } else {
        cateFilter += "," + code;
      }
    } else if (check === "B") {
      if (storeIdx === 0) {
        storeFilter = storeQuater + "filter.store_user.store_type=$in:" + code;
        storeIdx++;
      } else {
        storeFilter += "," + code;
      }
    } else if (check === "C") {
      if (dateIdx === 0) {
        dateFilter = dateQuater + "filter.insert_date=$btw:" + code;
        dateIdx++;
      }
      dateFilter += "," + code;
    } else if (check === "D") {
      if (progressIdx === 0) {
        progressFilter = progressQuater + "filter.progress=$in:" + code;
        progressIdx++;
      } else {
        progressFilter += "," + code;
      }
    }
  }

  returnValue = cateFilter + storeFilter + dateFilter + progressFilter;

  if (params[0].contents) {
    if (returnValue) {
      returnValue += "&search=" + params[0].contents;
    } else {
      returnValue += "?search=" + params[0].contents;
    }
  }

  if (params[0].limit) {
    if (returnValue) {
      returnValue += "&limit=" + params[0].limit;
    } else {
      returnValue += "?limit=" + params[0].limit;
    }
  }

  if (params[0].page) {
    if (returnValue) {
      returnValue += "&page=" + params[0].page;
    } else {
      returnValue += "?page=" + params[0].page;
    }
  }

  if (params[0].orderBy) {
    let orderCode = "";
    if (params[0].orderBy === "최신순") {
      orderCode = "insert_date:DESC";
    } else if (params[0].orderBy === "오래된순") {
      orderCode = "insert_date:ASC";
    } else if (params[0].orderBy === "가나다순") {
      orderCode += "contents:ASC";
    }

    if (returnValue) {
      returnValue += "&sortBy=" + orderCode;
    } else {
      returnValue += "?sortBy=" + orderCode;
    }
  }

  return returnValue;
};

export const getPathValue = () => {
  const pathname = location.pathname;
  const pathnameSplit = pathname.split("/");
  const index: any = pathnameSplit[2];
  if (index) {
    return index;
  } else {
    return "";
  }
};

export default setQueryString;
